

const Dailyessentials = [
  {
    id: 1,
    name: "Milk 1L",
    image:  require("../images/Milk.webp"),
    // price: 55,
    // category: "Dairy",
    description: "Fresh organic milk from local farms.",
  },
  {
    id: 2,
    name: "Eggs",
   image:  require("../images/egg.jpg"),
    // price: 45,
    // category: "Bakery",
    description: "Whole wheat brown bread, high in fiber.",
  },
  {
    id: 3,
    name: "Coffee",
image:  require("../images/cofee.avif"),
    // price: 75,
    // category: "Poultry",
    description: "Farm fresh, antibiotic-free eggs.",
  },
  {
    id: 4,
    name: "Organic Bananas (1 kg)",
    image:  require("../images/banana.jpg"),
    // price: 40,
    // category: "Fruits",
    description: "Naturally ripened bananas, chemical-free.",
  },
  {
    id: 5,
    name: "Soap",
    image:  require("../images/soap.jpg"),
    // price: 240,
    // category: "Grocery",
    description: "High-quality whole wheat flour.",
  },
  {
    id: 6,
    name: "Oil",
   image:  require("../images/oil.jpg"),
    // price: 130,
    // category: "Grocery",
    description: "Light and healthy cooking oil.",
  },
];

export default Dailyessentials;
